import { useParams } from "react-router-dom";
import withAuth from "../../components/auth";
import { injectIntl } from "react-intl";

function GameDetail(props) {
  /*const intl = useIntl();
  const history = useHistory();
  const user = jwt_decode(localStorage.getItem("token"));*/
  
  let { id } = useParams();  

  return (
    <>
      <game-detail game-id={id} />
    </>
  );
}

export default injectIntl(withAuth(GameDetail));
